// This function allow to reference async chunks
__webpack_require__.k = (chunkId) => {
	// return url for filenames based on template
	return "style/" + "d729a3599fd95211" + ".css";
};